/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Email_PlaceholderInputs */

const en_business_form_email_placeholder = /** @type {(inputs: Business_Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@company.com`)
};

const es_business_form_email_placeholder = /** @type {(inputs: Business_Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@empresa.com`)
};

/**
* | output |
* | --- |
* | "you@company.com" |
*
* @param {Business_Form_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_email_placeholder = /** @type {((inputs?: Business_Form_Email_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Email_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_email_placeholder(inputs)
	return en_business_form_email_placeholder(inputs)
});